import React, { PropsWithChildren } from "react";

import PlayIcon from "../icons/PlayIcon";
import inputElementStyles from "../styles/InputElements.module.css";

import styles from "./SelectCustomSimple.module.css";

interface Props {
  value: string;
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const SelectCustomSimple = (props: PropsWithChildren<Props>) => {
  const { value, onChange } = props;
  return (
    <span className={styles.Container}>
      <select
        value={value}
        onChange={onChange}
        className={`${inputElementStyles.SelectCustom} ${inputElementStyles.Padding} ${inputElementStyles.Input}`}
      >
        {props.children}
      </select>
      <span className={`${styles.SelectIcon}`}>
        <PlayIcon />
      </span>
    </span>
  );
};

export default SelectCustomSimple;
